<template>
<div class="container-fluid" >

 <div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i class="fas fa-list mr-2" aria-hidden="true"></i>STOCK BRAND EAN LIST</h4>
  </div> 

 <div  class="card-body"> 
  

<div class="row">
<div v-if="items.length==0" class="col-md-4"> 

  <div class="card border-info" >
  <div class="card-header  bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">


  <form name="movementSearch" v-on:submit.prevent="submit()">
    <!--
    <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>    
    -->  
    <brand-list v-bind:props="brand" @update="setBrandId"></brand-list>      
   
   <!-- <line-select :key="refreshLine" v-bind:optionBase="true"  v-bind:supplierId="supplier.Id" v-bind:isActive="items.length==0" @update="setLineId"></line-select>-->
    <season-select v-bind:props="season"  @update="setSeasonId"></season-select>
    <year-select  v-bind:props="season_year" @update="setYear"></year-select>
    <department-select v-bind:props="department" @update="setDepartmentId"></department-select>
    <category-select v-bind:props="categoryGroup"  @update="setCategoryId"></category-select>
    
    <stock-filter class="ml-4 mt-1 mb-1" @update="setStockFilter"></stock-filter>

    <div class="card-footer bg-transparent border-info"> 
      <alert-box  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
        <button :disabled="spinner" type="submit"  class="btn btn-primary float-right">
          <i class="far fa-play-circle mr-2"></i>
          ESEGUI
          <span v-if="spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
        </button>   

        
    </div>

  </form>
  

  </div>
</div>
</div>


<div v-else class="col">

  <button v-if="items.length>0"  @click="items=[],stock=1" type="button"  class="btn btn-secondary mb-1">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    ANNULLA
  </button> 

<div>
  <div class="table-wrapper-scroll-y my-custom-scrollbar mt-2">

  <table id="my-table"  class="table table-hover table-sm table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col">#</th>    
      
        
        <th scope="col">ID</th>
        <th scope="col">CODICE ARTICOLO</th>
        <th scope="col">BRAND</th>
        <th scope="col">CATEGORIA</th>
        <th scope="col">COLORE</th>
        <th scope="col">COLORE SUPPLIER</th>
        <th scope="col">MISURA</th>
        <th scope="col">EAN</th>
        <th scope="col">REPARTO</th>
        <th scope="col">STAGIONE</th>
        <th class="text-right" scope="col">Q.TA'</th>
        
        <th class="text-right">PREZZO RETAIL</th>
       
      </tr>
    </thead>
    <tbody>
      <tr data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in items" :key="index">
        <td>{{index+1}}</td>
      
        
        <td>{{item.productId}}</td>
        <td>{{item.sku}}
        </td>
        <td>{{item.brand}}</td>
        <td>{{item.category}}</td>
        <td>{{item.color}}</td>
        <td>{{item.supplier_color}}</td>
        <td>{{item.size}}</td>
        <td>{{item.barcode}}</td>
        <td>{{item.department}}</td>
        <td>{{item.season}} - {{item.season_year}} </td>
        <td class="text-right">{{item.qty}} </td>
        <td class="text-right">{{item.price}} </td>

       
      </tr> 
    </tbody>

      

  </table>


</div>


  <button :disabled="items.length==0 || spinner_pdf == true" @click="pdf()" type="button"   class="btn btn-primary mt-2 mr-3 float-right">

    <i class="fas fa-file-export mr-2"></i>
      ESPORTA PDF
      <span v-if="spinner_pdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  </button> 




  
<img-zoom v-if="img" @close="closeImg()" v-bind:img='img'></img-zoom>

</div>
</div>
</div>
</div>
</div>

</div>
</template>
<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import supplierSelect    from '@/components/common/SupplierSelect_1.vue'
import seasonSelect      from '@/components/common/SeasonSelect_1.vue'
import yearSelect        from '@/components/common/YearSelect_1.vue'
import departmentSelect  from '@/components/common/DepartmentSelect_1.vue'
import categorySelect    from '@/components/common/CategoryGroupingSelect_1.vue'
import productStock      from '@/components/common/ProductStock.vue'
import lineSelect        from '@/components/common/LineSelect.vue'
import brandList         from '@/components/common/CompanyBrandSelect_1.vue'

import imgZoom           from '@/components/common/ProductImg.vue'
import stockFilter       from '@/components/common/StockFilter.vue'
import jsPDF             from 'jspdf'

export default {
  components: {alertBox,supplierSelect,seasonSelect,yearSelect,departmentSelect,categorySelect,productStock,lineSelect,imgZoom,brandList,stockFilter},
  data() {
    return {


      brand           :
      {
        Id            : '',
        required      : true,

      },
      supplier        : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        type          : true


      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
       
      },
      categoryGroup   : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
       
      },
      
      
      lineId          : 0,
            
      
      spinner         : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
    
      items           : [],
   
      stock           : 1,
      img             : '',
      
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {
    
   
  },
  methods: {


   


    setAltImg(event) 
    { 
        event.target.src = require("@/assets/no_img.jpg")
    },         
 
    imgZoom(img)
    {
        this.img = img
    },
    closeImg()
    {
        this.img = ''
    },

    
    fmt1(value)
    { 
      if(!isNaN(value))
      {
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
      }
    },

    setBrandId(brandId)
    {
      this.brand.Id = brandId
      

    },
    setCategoryId(categoryId)
    {      
      this.categoryGroup.Id = categoryId
    },  
    setSupplierId(supplierId)
    {
        this.supplier.Id = supplierId        
        this.refreshLine++
    },  
    setDepartmentId(departmentId)
    {
      this.department.Id = departmentId
    },
    setSeasonId(seasonId)
    {   
        
        this.season.Id = seasonId
    },  
    setYear(year)
    {
        this.season_year.year = year
    },
    setLineId(lineId)
    {
      this.lineId = lineId
    },
    setStockFilter(stock)
    {
      this.stock = stock
    },
    submit() 
    {
      this.getData()
      
    },  
    
      
    async  pdf()
    {

      
      const addFooters = doc => {
      const pageCount = doc.internal.getNumberOfPages()
      doc.setFont('helvetica', 'italic')
      doc.setFontSize(8)
      for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i)

        doc.text('Pag. ' + String(i) + ' di ' + String(pageCount), 50,200, {
        align: 'center'})
      }
      }
       
       //this.spinner_pdf = true


       const doc = new jsPDF(
         
         {
         
       orientation: "landscape",

        
      })
      doc.setFontSize(10)
      var d = new Date();
      var n = d.toLocaleDateString();
      var t = d.toLocaleTimeString();
      doc.text("STOCK BRAND EAN LIST " + n + ' ' + t , 15, 10);
      doc.setFontSize(10)
      //doc.text(' - Stagione ' + this.title.season + ' ' + this.title.year + ' - Reparto ' + this.title.department, 15, 15);
     
      doc.autoTable(
      
    
       { html: '#my-table',
       margin       : {top:20},
       showFoot: 'lastPage',
       footStyles:{fontStyle:'bold',fillColor:'white',textColor:'black',fontSize:7,cellWidth: 'wrap',},
/*
          didParseCell: function(data) {
            if (data.row.cells[0].text == 'Tot. Raggruppamento') {
              
              
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.fontSize = 6
              //console.log(data.row.cells[0].text)

            }
          


          
          }, 

*/

       styles : {
          font       : 'helvetica',
          //rowHeight  : 5,  
          fontSize   : 9,
          }
        })
      
     
     addFooters(doc) 
    //var string = doc.output('datauristring');
    //doc.output('dataurlnewwindow');
    var fileName = 'Report'
    window.open(doc.output('bloburl', { filename: fileName }), '_blank');
    //console.log(string)
    //this.spinner_pdf = false
    //doc.save('sellOut_' + Date.now()  + '.pdf', {returnPromise:true}).then(this.spinner_pdf=false);
      
     
    },
   
    async getData() {
      
    
      
      this.items  = []
      
  
      this.msg.title = ''
      var sp = {'sp' : 'spStockBrandEanList'}
      
      var data  = {

        'companyId'         : this.company.Id,
        'supplierId'        : this.supplier.Id,
        'seasonId'          : this.season.Id,
        'departmentId'      : this.department.Id,
        'categoryId'        : this.categoryGroup.Id,
        'season_year'       : this.season_year.year,
        'stock'             : this.stock,
        'brand'             : this.brand.Id

      }
      
      

      var json  = Object.assign(data, sp)      
      this.spinner = true


      

      await api.post(json).then(res => {
         
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]
             
                 
              if(this.items.length==0)
              {
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      

    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position: relative;
height: 700px;
overflow: auto;
}
.pointer:hover
{
  _background-color: white;
  
  cursor: pointer;
}

.detail tr:nth-child(1) th  {
    background   : yellow;
}


.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : #FFFFE0;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;

 }

 .tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #66CCFF; 
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;

 }
.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
.dotRed
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}
div.catalog {
 
  height: 700px;
  _width: 200px;
  overflow-y: scroll;
}

.my-custom-scrollbar {
position : relative;
height   : 600px;
overflow : auto;
}
.table-wrapper-scroll-y {
display  : block;
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   :  hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }
</style>